import { Suspense, lazy } from 'react';
import { Navigate, Route, createRoutesFromElements } from 'react-router-dom';
import LoadingPage from '@pages/LoadingPage';

const DeliveryPersonLayout = lazy(() => import('@components/layout/DeliveryPersonLayout'));
const DeliveryPersonOrder = lazy(() => import('@pages/DeliveryPerson/DeliveryPersonOrder'));
const DeliveryPersonSuccess = lazy(() => import('@pages/DeliveryPerson/DeliveryPersonSuccess'));

/**
 * PLI-2031 — Route tree aislado para el repartidor.
 *
 * Se carga cuando `auth.isDeliveryPerson === true` (router swap).
 * Completamente separado del route tree del panel del comercio.
 */
export const deliveryPersonRoutes = createRoutesFromElements(
  <Route
    path="/"
    element={
      <Suspense fallback={<LoadingPage />}>
        <DeliveryPersonLayout />
      </Suspense>
    }
  >
    <Route index element={<Navigate to="repartidor/pedido" />} />
    <Route
      path="repartidor/pedido"
      element={
        <Suspense fallback={<LoadingPage />}>
          <DeliveryPersonOrder />
        </Suspense>
      }
    />
    <Route
      path="repartidor/completado"
      element={
        <Suspense fallback={<LoadingPage />}>
          <DeliveryPersonSuccess />
        </Suspense>
      }
    />
    <Route path="*" element={<Navigate to="repartidor/pedido" />} />
  </Route>,
);
